import * as React from "react";
import Select from "react-select";
import { EmploymentShape } from "@eave/shared/types/api";
import {
  findFieldValue,
  employmentToEmploymentTypeString,
} from "web_modules/underwriter_dashboard/shared";
import { addressToStr } from "@eave/shared/utils/addresses";

import PaystubPanel from "./PaystubPanel";
import W2Panel from "./W2Panel";
import WVOEPanel from "./WVOEPanel";
import WorknumberWVOE from "./WorknumberWVOE";

const { FormattedDate } = require("react-intl");
const { Panel } = require("react-bootstrap");

interface EmploymentPanelProps {
  isPrimary: boolean;
  isCurrent: boolean;
  setDocId: Function;
  setEmploymentEIN: Function;
  einOptions: Object[];
  einOptionSelected: Object;
  employment: EmploymentShape;
  borrowerName: string;
  w2s: any;
  paystubs: any;
  wvoes: any;
  worknumbers: any;
}

class EmploymentPanel extends React.Component<EmploymentPanelProps, any> {
  render() {
    const {
      employment,
      w2s,
      borrowerName,
      isPrimary,
      isCurrent,
      paystubs,
      wvoes,
      worknumbers,
      setEmploymentEIN,
      einOptions,
      einOptionSelected,
    } = this.props;

    const recentPaystubs = paystubs.filter(paystub => !findFieldValue(paystub, "is_year_end"));
    const yearEndPaystubs = paystubs.filter(paystub =>
      Boolean(findFieldValue(paystub, "is_year_end")),
    );

    let employmentType;
    if (isPrimary) {
      employmentType = "Primary";
    } else if (isCurrent) {
      employmentType = "Secondary";
    } else {
      employmentType = "Prior";
    }

    return (
      <Panel defaultExpanded bsStyle={isPrimary ? "primary" : "default"}>
        <Panel.Heading>
          <Panel.Title toggle>{`${employmentType} Employment`}</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <div className="income_doc_detail_list_container">
              <div className="income_doc_employment_summary">
                <dl className="dl-horizontal">
                  <dt>Borrower {employment.borrower_entity}</dt>
                  <dd>{borrowerName}</dd>
                  <dt>Employer</dt>
                  <dd>{employment.name}</dd>
                  <dt>Address</dt>
                  <dd>
                    {addressToStr(
                      employment.address_line1,
                      employment.address_line2,
                      employment.city,
                      employment.state,
                      employment.postal_code,
                    )}{" "}
                  </dd>
                  <dt>Phone</dt>
                  <dd>{employment.contact}</dd>
                  <dt>Distance in miles from primary residence to employment</dt>
                  <dd />
                </dl>
              </div>
              <div className="income_doc_employment_summary">
                <dl className="dl-horizontal">
                  <dt>Employment Type</dt>
                  <dd>{employmentToEmploymentTypeString(employment)}</dd>
                  <dt>Position Title</dt>
                  <dd>{employment.title}</dd>
                  <dt>Employment Start Date</dt>
                  <dd>
                    {employment.start_date && (
                      <FormattedDate value={employment.start_date} timeZone="UTC" />
                    )}
                  </dd>
                  <dt>Employment End Date</dt>
                  <dd>
                    {employment.end_date ? (
                      <FormattedDate value={employment.end_date} timeZone="UTC" />
                    ) : (
                      "Current"
                    )}
                  </dd>
                  <dt>Yrs In This Employment</dt>
                  <dd>{employment.years_at_employment}</dd>
                  <dt>
                    {employment.income_type === "selfEmployed"
                      ? "Percent Ownership"
                      : "Average Hours Per Week"}
                  </dt>
                  <dd>
                    {employment.income_type === "selfEmployed"
                      ? employment.self_employed_ownership_percent
                      : recentPaystubs.length > 0 &&
                        findFieldValue(recentPaystubs[0], "hours_per_week")}
                  </dd>
                  <dt>EIN</dt>
                  <dd>
                    <Select
                      clearable
                      placeholder="Select EIN..."
                      value={einOptionSelected}
                      options={einOptions}
                      onChange={setEmploymentEIN.bind(this, employment.id)}
                    />
                  </dd>
                </dl>
              </div>
            </div>
            <br />
            {worknumbers.length > 0 && (
              <WorknumberWVOE
                docs={worknumbers}
                header="Worknumber Written Verification of Employment"
                setDocId={this.props.setDocId.bind(this)}
                employment={employment}
              />
            )}
            {wvoes.length > 0 && (
              <WVOEPanel
                docs={wvoes}
                header="Written Verification of Employment"
                setDocId={this.props.setDocId.bind(this)}
                employment={employment}
              />
            )}
            {recentPaystubs.length > 0 && (
              <PaystubPanel
                docs={recentPaystubs}
                employment={employment}
                header="Recent Paystubs"
                setDocId={this.props.setDocId.bind(this)}
                renderCurrent
              />
            )}
            {yearEndPaystubs.length > 0 && (
              <PaystubPanel
                docs={yearEndPaystubs}
                employment={employment}
                header="Year End Paystubs"
                setDocId={this.props.setDocId.bind(this)}
                renderCurrent={false}
              />
            )}
            {w2s.length > 0 && (
              <W2Panel docs={w2s} header="W2s" setDocId={this.props.setDocId.bind(this)} />
            )}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default EmploymentPanel;
